export default "__VITE_ASSET__C1SWuXAh__"